export default __webpack_public_path__ + "static/media/NW0120.34I-35465_-20510_0.af021dd4.jpg";